import { createFileRoute } from '@tanstack/react-router';

import { ProductDetailPage } from '~/features/catalog-operations/pages/product-detail-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

/** Detail view for a product reached from the global needs-attention list.
 *  These products haven't been enriched yet, so `hideEnrichment` skips the
 *  enrichment query and the corresponding UI sections.
 *  `from='needs-attention'` triggers the alternate breadcrumb (back to
 *  "Products Needing Attention" instead of "Batch Details > Products"). */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { productId } = Route.useParams();
  return (
    <RequireChannelConnection>
      <ProductDetailPage batchId="" productId={productId} from="needs-attention" hideEnrichment />
    </RequireChannelConnection>
  );
}
